import React, { useEffect, useRef } from "react";
import * as d3 from "d3";
import { Box, Typography, Select, MenuItem } from "@mui/material";

const D3BarChart = ({
  data = [],
  xKey = "day",
  yKey = "value",
  title = "Bar Chart",
  color = "#818CF8",
  width = 400,
  height = 250,
  timeFrames = [],
  selectedTimeFrame,
  onTimeFrameChange,
}) => {
  const svgRef = useRef();

  useEffect(() => {
    if (!data.length) return;

    const margin = { top: 20, right: 20, bottom: 30, left: 50 };
    const innerWidth = width - margin.left - margin.right;
    const innerHeight = height - margin.top - margin.bottom;

    const svg = d3.select(svgRef.current);
    svg.selectAll("*").remove();

    const xScale = d3
      .scaleBand()
      .domain(data.map((d) => d[xKey]))
      .range([margin.left, width - margin.right])
      .padding(0.3);

    const yScale = d3
      .scaleLinear()
      .domain([0, d3.max(data, (d) => d[yKey]) || 100])
      .nice()
      .range([height - margin.bottom, margin.top]);

    svg
      .append("g")
      .attr("transform", `translate(0,${height - margin.bottom})`)
      .call(d3.axisBottom(xScale).tickSize(0))
      .selectAll("text")
      .style("font-size", "12px");

    svg
      .append("g")
      .attr("transform", `translate(${margin.left},0)`)
      .call(d3.axisLeft(yScale).ticks(5));

    svg
      .selectAll("rect")
      .data(data)
      .enter()
      .append("rect")
      .attr("x", (d) => xScale(d[xKey]))
      .attr("y", (d) => yScale(d[yKey]))
      .attr("width", xScale.bandwidth())
      .attr("height", (d) => innerHeight - (yScale(d[yKey]) - margin.top))
      .attr("fill", color);
  }, [data, xKey, yKey, color, width, height]);

  return (
    <Box p={2}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body1" fontWeight="bold">
          {title}
        </Typography>
        {timeFrames.length > 0 && (
          <Select
            value={selectedTimeFrame}
            onChange={(e) => onTimeFrameChange?.(e.target.value)}
            size="small"
            variant="standard"
          >
            {timeFrames.map((frame) => (
              <MenuItem key={frame} value={frame}>
                {frame}
              </MenuItem>
            ))}
          </Select>
        )}
      </Box>
      <svg ref={svgRef} width={width} height={height}></svg>
    </Box>
  );
};

export default D3BarChart;
